import cx from "classnames";
import React, { forwardRef } from "react";
import Spinner from "@trainline-shareable/spinner";
import * as styles from "./Button.module.css";
const renderSideIcon = (Icon) => /* @__PURE__ */ React.createElement("span", {
  className: styles.iconWrapper,
  "data-testid": "button-side-icon"
}, /* @__PURE__ */ React.createElement(Icon, {
  className: styles.icon
}));
const Button = ({
  testId = "button",
  textSize = "large",
  variant = "primary",
  fullWidth = false,
  icon,
  alignIcon = "left",
  children,
  className,
  as: As = "button",
  textWeight = "auto",
  active = false,
  loading = false,
  ...rest
}, ref) => /* @__PURE__ */ React.createElement(As, {
  className: cx(styles.root, {
    [styles.micro]: textSize === "micro",
    [styles.mini]: textSize === "mini",
    [styles.small]: textSize === "small",
    [styles.body]: textSize === "body",
    [styles.large]: textSize === "large",
    [styles.title2]: textSize === "title2",
    [styles.title3]: textSize === "title3",
    [styles.title4]: textSize === "title4",
    [styles.primary]: variant === "primary",
    [styles.secondary1]: variant === "secondary1",
    [styles.secondary2]: variant === "secondary2",
    [styles.secondary3]: variant === "secondary3",
    [styles.tertiary]: variant === "tertiary",
    [styles.destructive]: variant === "destructive",
    [styles.ghost]: variant === "ghost",
    [styles.link]: variant === "link",
    [styles.fullWidth]: fullWidth,
    [styles.fontWeightNormal]: textWeight === "normal",
    [styles.active]: active
  }, className),
  "data-testid": testId,
  ref,
  ...rest
}, icon && alignIcon === "left" && renderSideIcon(icon), loading && /* @__PURE__ */ React.createElement("div", {
  className: cx(styles.spinner)
}, /* @__PURE__ */ React.createElement(Spinner, null)), children, icon && alignIcon === "right" && renderSideIcon(icon));
var Button_default = forwardRef(Button);
export {
  Button,
  Button_default as default
};
